import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '',
    component: Layout,
    redirect: '/home',
    meta: {title: '首页', icon: 'home'},
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: '首页', icon: 'dashboard'}
    },
    // {
    //   name: 'document',
    //   path: 'https://www.macrozheng.com',
    //   meta: {title: '学习教程', icon: 'document'}
    // },
    // {
    //   name: 'video',
    //   path: 'https://www.macrozheng.com/mall/catalog/mall_video.html',
    //   meta: {title: '视频教程', icon: 'video'}
    // },
    ]
  }
]

export const asyncRouterMap = [
  {
    path: '/pms',
    component: Layout,
    redirect: '/pms/product',
    name: 'pms',
    meta: {title: '商品', icon: 'product'},
    children: [
      // {
      //   path: 'product',
      //   name: 'product',
      //   component: () => import('@/views/pms/product/index'),
      //   meta: {title: '商品列表', icon: 'product-list'}
      // },
      {
        path: 'question',
        name: 'question',
        component: () => import('@/views/pms/question/question'),
        meta: {title: '题目管理', icon: 'product-add'}
      },
      {
        path: 'questionCategory',
        name: 'questionCategory',
        component: () => import('@/views/pms/question/category'),
        meta: {title: '题库大类管理', icon: 'product-cate'}
      },
      {
        path: 'questionBank',
        name: 'questionBank',
        component: () => import('@/views/pms/question/bank'),
        meta: {title: '题库管理', icon: 'product-list'}
      },
      {
        path: 'controlSkillBrandList',
        name: 'controlSkillBrandList',
        component: () => import('@/views/pms/master/controlSkillBrand/index'),
        meta: {title: '工控技术品牌', icon: 'product-add'}
      },
      {
        path: 'controlSkillBrandAdd',
        name: 'controlSkillBrandAdd',
        component: () =>  import('@/views/pms/master/controlSkillBrand/add'),
        meta: {title: '添加工控技术品牌', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'controlSkillBrandUpdate',
        name: 'controlSkillBrandUpdate',
        component: () =>  import('@/views/pms/master/controlSkillBrand/update'),
        meta: {title: '修改工控技术品牌', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'controlSkillList',
        name: 'controlSkillList',
        component: () => import('@/views/pms/master/controlSkill/index'),
        meta: {title: '工控技术', icon: 'product-add'}
      },
      {
        path: 'controlSkillAdd',
        name: 'controlSkillAdd',
        component: () =>  import('@/views/pms/master/controlSkill/add'),
        meta: {title: '添加工控技术', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'controlSkillUpdate',
        name: 'controlSkillUpdate',
        component: () =>  import('@/views/pms/master/controlSkill/update'),
        meta: {title: '修改工控技术', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'coolToolBrandList',
        name: 'coolToolBrandList',
        component: () => import('@/views/pms/coolTool/coolToolBrandList'),
        meta: {title: '中央空调分类列表', icon: 'product-add'}
      },
      {
        path: 'coolToolBrandAdd',
        name: 'coolToolBrandAdd',
        component: () => import('@/views/pms/coolTool/coolToolBrandAdd'),
        meta: {title: '添加中央空调分类', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'coolToolBrandEdit',
        name: 'coolToolBrandEdit',
        component: () => import('@/views/pms/coolTool/coolToolBrandEdit'),
        meta: {title: '编辑中央空调分类', icon: 'product-add'},
        hidden: true
      },

      {
        path: 'pointLightList',
        name: 'pointLightList',
        component: () => import('@/views/pms/pointLight/pointLightList'),
        meta: {title: '指示灯列表', icon: 'product-add'}
      },
      {
        path: 'pointLightAdd',
        name: 'pointLightAdd',
        component: () =>  import('@/views/pms/pointLight/pointLightAdd'),
        meta: {title: '添加指示灯', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'pointLightEdit',
        name: 'pointLightEdit',
        component: () =>  import('@/views/pms/pointLight/pointLightEdit'),
        meta: {title: '编辑指示灯', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'pointLightItem',
        name: 'pointLightItem',
        component: () =>  import('@/views/pms/pointLight/pointLightItem'),
        meta: {title: '详情列表', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'coolToolList',
        name: 'coolToolList',
        component: () => import('@/views/pms/coolTool/coolTool'),
        meta: {title: '中央空调云资料列表', icon: 'product-add'}
      },
      {
        path: 'coolToolAdd',
        name: 'coolToolAdd',
        component: () => import('@/views/pms/coolTool/coolToolAdd'),
        meta: {title: '添加中央空调云资料', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'coolToolUpdate',
        name: 'coolToolUpdate',
        component: () => import('@/views/pms/coolTool/coolToolUpdate'),
        meta: {title: '修改中央空调资料', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'coolToolItem',
        name: 'coolToolItem',
        component: () =>  import('@/views/pms/coolTool/coolToolItem'),
        meta: {title: '详情列表', icon: 'product-add'},
        hidden: true
      },

      {
        path: 'systemManageList',
        name: 'systemManageList',
        component: () => import('@/views/pms/systemManage/systemManageList'),
        meta: {title: '产品系统管理', icon: 'product-add'},

      },
      {
        path: 'systemManageUpdate',
        name: 'systemManageUpdate',
        component: () => import('@/views/pms/systemManage/systemManageUpdate'),
        meta: {title: '修改产品系统', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'repairDataList',
        name: 'repairDataList',
        component: () => import('@/views/pms/master/repairData/index'),
        meta: {title: '维修数据', icon: 'product-add'}
      },
      {
        path: 'repairDataAdd',
        name: 'repairDataAdd',
        component: () => import('@/views/pms/master/repairData/add'),
        meta: {title: '添加维修数据', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'repairDataEdit',
        name: 'repairDataEdit',
        component: () => import('@/views/pms/master/repairData/update'),
        meta: {title: '编辑维修数据', icon: 'product-add'},
        hidden: true
      },

      {
        path: 'electricalDataList',
        name: 'electricalDataList',
        component: () => import('@/views/pms/master/electricalData/index'),
        meta: {title: '电工大师资料', icon: 'product-add'}
      },
      {
        path: 'electricalDataAdd',
        name: 'electricalDataAdd',
        component: () => import('@/views/pms/master/electricalData/add'),
        meta: {title: '添加电工分类', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'electricalDataEdit',
        name: 'electricalDataEdit',
        component: () => import('@/views/pms/master/electricalData/update'),
        meta: {title: '编辑电工分类', icon: 'product-add'},
        hidden: true
      },

      {
        path: 'factoryInfoList',
        name: 'factoryInfoList',
        component: () => import('@/views/pms/master/factoryInfo/index'),
        meta: {title: '维修资料', icon: 'product-add'}
      },
      {
        path: 'factoryInfoAdd',
        name: 'factoryInfoAdd',
        component: () => import('@/views/pms/master/factoryInfo/add'),
        meta: {title: '添加维修资料', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'factoryInfoEdit',
        name: 'factoryInfoEdit',
        component: () => import('@/views/pms/master/factoryInfo/update'),
        meta: {title: '编辑维修资料', icon: 'product-add'},
        hidden: true
      },

      {
        path: 'faultCase',
        name: 'faultCase',
        component: () => import('@/views/pms/master/faultCase/index'),
        meta: {title: '故障现象', icon: 'product-add'}
      },
      {
        path: 'faultCaseAdd',
        name: 'faultCaseAdd',
        component: () => import('@/views/pms/master/faultCase/add'),
        meta: {title: '添加故障现象', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'faultCaseUpdate',
        name: 'faultCaseUpdate',
        component: () => import('@/views/pms/master/faultCase/update'),
        meta: {title: '修改故障现象', icon: 'product-add'},
        hidden: true
      },

      {
        path: 'faultCode',
        name: 'faultCode',
        component: () => import('@/views/pms/master/faultCode/index'),
        meta: {title: '故障码', icon: 'product-add'}
      },
      {
        path: 'faultCodeAdd',
        name: 'faultCodeAdd',
        component: () => import('@/views/pms/master/faultCode/add'),
        meta: {title: '添加故障码', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'faultCodeUpdate',
        name: 'faultCodeUpdate',
        component: () => import('@/views/pms/master/faultCode/update'),
        meta: {title: '修改故障码', icon: 'product-add'},
        hidden: true
      },
      {
        path: '/pms',
        component: Layout,
        redirect: '/pms/product',
        name: 'pms',
        meta: { title: '商品', icon: 'product' },
        children: [
          // ... 其他路由
          {
            path: 'navigation',
            name: 'navigation',
            component: () => import('@/views/pms/navigation/navigation'),
            meta: { title: '导航栏管理', icon: 'product-list' }
          }
        ]
      },

      // {
      //   path: 'addProduct',
      //   name: 'addProduct',
      //   component: () => import('@/views/pms/product/add'),
      //   meta: {title: '添加商品', icon: 'product-add'}
      // },
      // {
      //   path: 'updateProduct',
      //   name: 'updateProduct',
      //   component: () => import('@/views/pms/product/update'),
      //   meta: {title: '修改商品', icon: 'product-add'},
      //   hidden: true
      // },
      // {
      //   path: 'productCate',
      //   name: 'productCate',
      //   component: () => import('@/views/pms/productCate/index'),
      //   meta: {title: '商品分类', icon: 'product-cate'}
      // },
      // {
      //   path: 'addProductCate',
      //   name: 'addProductCate',
      //   component: () => import('@/views/pms/productCate/add'),
      //   meta: {title: '添加商品分类'},
      //   hidden: true
      // },
      // {
      //   path: 'updateProductCate',
      //   name: 'updateProductCate',
      //   component: () => import('@/views/pms/productCate/update'),
      //   meta: {title: '修改商品分类'},
      //   hidden: true
      // },
      // {
      //   path: 'productAttr',
      //   name: 'productAttr',
      //   component: () => import('@/views/pms/productAttr/index'),
      //   meta: {title: '商品类型', icon: 'product-attr'}
      // },
      // {
      //   path: 'productAttrList',
      //   name: 'productAttrList',
      //   component: () => import('@/views/pms/productAttr/productAttrList'),
      //   meta: {title: '商品属性列表'},
      //   hidden: true
      // },
      // {
      //   path: 'addProductAttr',
      //   name: 'addProductAttr',
      //   component: () => import('@/views/pms/productAttr/addProductAttr'),
      //   meta: {title: '添加商品属性'},
      //   hidden: true
      // },
      // {
      //   path: 'updateProductAttr',
      //   name: 'updateProductAttr',
      //   component: () => import('@/views/pms/productAttr/updateProductAttr'),
      //   meta: {title: '修改商品属性'},
      //   hidden: true
      // },
      // {
      //   path: 'brand',
      //   name: 'brand',
      //   component: () => import('@/views/pms/brand/index'),
      //   meta: {title: '品牌管理', icon: 'product-brand'}
      // },
      {
        path: 'brand',
        name: 'brand',
        component: () => import('@/views/pms/master/brand/index'),
        meta: {title: '品牌管理', icon: 'product-brand'}
      },
      {
        path: 'addBrand',
        name: 'addBrand',
        component: () => import('@/views/pms/master/brand/add'),
        meta: {title: '添加品牌'},
        hidden: true
      },
      {
        path: 'updateBrand',
        name: 'updateBrand',
        component: () => import('@/views/pms/master/brand/update'),
        meta: {title: '编辑品牌'},
        hidden: true
      },
      {
        path: 'category',
        name: 'category',
        component: () => import('@/views/pms/master/category/index'),
        meta: {title: '分类管理', icon: 'product-cate'}
      },
      {
        path: 'addProductCate',
        name: 'addProductCate',
        component: () => import('@/views/pms/master/category/add'),
        meta: {title: '添加分类'},
        hidden: true
      },
      {
        path: 'updateProductCate',
        name: 'updateProductCate',
        component: () => import('@/views/pms/master/category/update'),
        meta: {title: '修改分类'},
        hidden: true
      },
    ]
  },
  {
    path: '/oms',
    component: Layout,
    redirect: '/oms/order',
    name: 'oms',
    meta: {title: '订单', icon: 'order'},
    children: [
      // {
      //   path: 'order',
      //   name: 'order',
      //   component: () => import('@/views/oms/order/index'),
      //   meta: {title: '订单列表', icon: 'product-list'}
      // },
      // {
      //   path: 'orderDetail',
      //   name: 'orderDetail',
      //   component: () => import('@/views/oms/order/orderDetail'),
      //   meta: {title: '订单详情'},
      //   hidden:true
      // },
      // {
      //   path: 'deliverOrderList',
      //   name: 'deliverOrderList',
      //   component: () => import('@/views/oms/order/deliverOrderList'),
      //   meta: {title: '发货列表'},
      //   hidden:true
      // },
      // {
      //   path: 'orderSetting',
      //   name: 'orderSetting',
      //   component: () => import('@/views/oms/order/setting'),
      //   meta: {title: '订单设置', icon: 'order-setting'}
      // },
      // {
      //   path: 'returnApply',
      //   name: 'returnApply',
      //   component: () => import('@/views/oms/apply/index'),
      //   meta: {title: '退货申请处理', icon: 'order-return'}
      // },
      // {
      //   path: 'returnReason',
      //   name: 'returnReason',
      //   component: () => import('@/views/oms/apply/reason'),
      //   meta: {title: '退货原因设置', icon: 'order-return-reason'}
      // },
      // {
      //   path: 'returnApplyDetail',
      //   name: 'returnApplyDetail',
      //   component: () => import('@/views/oms/apply/applyDetail'),
      //   meta: {title: '退货原因详情'},
      //   hidden:true
      // },
      {
        path: 'order',
        name: 'order',
        component: () => import('@/views/oms/master/order/index'),
        meta: {title: '订单列表', icon: 'product-list'}
      },
      {
        path: 'balanceLog',
        name: 'balanceLog',
        component: () => import('@/views/oms/master/balance/index'),
        meta: { title: '余额变更历史', icon: 'balance-log' }
      },
      {
        path: 'withdraw',
        name: 'withdraw',
        component: () => import('@/views/oms/master/withdraw/index'),
        meta: {title: '提现管理', icon: 'product-list'}
      },
    ]
  },
  {
    path:'/sms',
    component: Layout,
    redirect: '/sms/coupon',
    name: 'sms',
    meta: {title: '营销', icon: 'sms'},
    children: [

      {
        path: 'promoCodeList',
        name: 'promoCodeList',
        component: () => import('@/views/oms/master/promoCode/list'),
        meta: {title: '优惠码列表', icon: 'product-list'}
      },
      {
        path: 'promoCodeApply',
        name: 'promoCodeApply',
        component: () => import('@/views/oms/master/promoCode/index'),
        meta: {title: '优惠码审核列表', icon: 'product-list'}
      },
      {
        path: 'promoCodeLog',
        name: 'promoCodeLog',
        component: () => import('@/views/oms/master/promoCode/log'),
        meta: {title: '优惠码返点记录', icon: 'product-list'}
      },

      {
        path: 'advertise',
        name: 'advertise',
        component: () => import('@/views/sms/master/advertise/index'),
        meta: {title: '广告列表', icon: 'sms-ad'}
      },
      // {
      //   path: 'addAdvertise',
      //   name: 'addHomeAdvertise',
      //   component: () => import('@/views/sms/advertise/add'),
      //   meta: {title: '添加广告'},
      //   hidden:true
      // },
      {
        path: 'addAdvertise',
        name: 'addAdvertise',
        component: () => import('@/views/sms/master/advertise/add'),
        meta: {title: '添加广告'},
        hidden:true
      },
      // {
      //   path: 'updateAdvertise',
      //   name: 'updateHomeAdvertise',
      //   component: () => import('@/views/sms/advertise/update'),
      //   meta: {title: '编辑广告'},
      //   hidden:true
      // }
      {
        path: 'updateAdvertise',
        name: 'updateHomeAdvertise',
        component: () => import('@/views/sms/master/advertise/update'),
        meta: {title: '编辑广告'},
        hidden:true
      },

      {
        path: 'vipPlan',
        name: 'vipPlan',
        component: () => import('@/views/sms/master/vipPlan/index'),
        meta: {title: 'VIP服务', icon: 'sms-ad'}
      },
      {
        path: 'addVipPlan',
        name: 'addVipPlan',
        component: () => import('@/views/sms/master/vipPlan/add'),
        meta: {title: '添加VIP服务'},
        hidden:true
      },

      {
        path: 'updateVipPlan',
        name: 'updateVipPlan',
        component: () => import('@/views/sms/master/vipPlan/update'),
        meta: {title: '编辑VIP服务'},
        hidden:true
      },
      {
        path: 'activationCodeList',
        name: 'activationCodeList',
        component: () => import('@/views/sms/master/activationCode/index'),
        meta: {title: '激活码列表', icon: 'product-list'}
      },
      {
        path: 'activationCodeUseList',
        name: 'activationCodeUseList',
        component: () => import('@/views/sms/master/activationCodeUse/index'),
        meta: {title: '激活码使用记录', icon: 'product-list'}
      },

    ]
  },
  {
    path:'/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {title: '权限', icon: 'ums'},
    children: [
      {
        path: 'member',
        name: 'member',
        component: () => import('@/views/ums/member/index'),
        meta: {title: '用户列表', icon: 'ums-admin'}
      },
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: {title: '管理员列表', icon: 'ums-admin'}
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: {title: '角色列表', icon: 'ums-role'}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: {title: '分配菜单'},
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: {title: '分配资源'},
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {title: '菜单列表', icon: 'ums-menu'}
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {title: '添加菜单'},
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {title: '修改菜单'},
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: {title: '资源列表', icon: 'ums-resource'}
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: {title: '资源分类'},
        hidden: true
      }
    ]
  },
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js